import React,{ FC, useEffect } from "react";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import { List, ListItemButton } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { useLocation } from 'react-router-dom'
import clsx from "clsx";

interface SingleLevelProps {
    item: {
        icon: string;
        title: string;
        to: string;
    };
    closeSideBar: () => any;
}


    const SingleLevel: FC<SingleLevelProps> = ({ item,closeSideBar = () => {}  }) => {
    const location = useLocation();

    const navigate = useNavigate();

    useEffect(() => {
        // console.log(`You changed the page to: ${location.pathname}`)
    }, [location]);

    const handleNavigate = (path: string) => {
        navigate(path)
    }

    return (
        <List component="div" disablePadding className={clsx("sidebarPill", location.pathname === item.to ? "activeSidebarPill" : "")}>
            <ListItemButton sx={{ pl: 4 }} onClick={() => { handleNavigate(item.to); }} >
                {item.icon && <ListItemIcon>{item.icon}</ListItemIcon>}
                <ListItemText primary={item.title} />
            </ListItemButton>
        </List>
    );
};

export default SingleLevel;